import Cookies from 'js-cookie'

const state = {
  token: Cookies.get('Admin-Token'),
  userInfo: JSON.parse(localStorage.getItem('UserInfo') || '{}')
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
    if (token) {
      Cookies.set('Admin-Token', token)
    } else {
      Cookies.remove('Admin-Token')
    }
  },
  SET_USER_INFO: (state, info) => {
    state.userInfo = info || {}
    localStorage.setItem('UserInfo', JSON.stringify(info || {}))
  }
}

const actions = {
  login({ commit }, data) {
    return import('@/api/auth').then(({ login }) => login(data)).then(res => {
      commit('SET_TOKEN', res.data.token)
      commit('SET_USER_INFO', res.data)
      return res.data
    })
  },
  logout({ commit }) {
    commit('SET_TOKEN', '')
    commit('SET_USER_INFO', {})
    return Promise.resolve()
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
